import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const keycloak = new Keycloak({
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "",
  url: process.env.REACT_APP_KEYCLOAK_URL || "",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "",
});

export default function KeycloakProvider(props: Props): ReactElement {
  const { children } = props;

  const currentPath = window.location.pathname;

  function isSharePath(path: string): boolean {
    return /^\/share\/[^/]+$/.test(path);
  }

  if (!keycloak) {
    return <>Loading...</>;
  }

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: "check-sso" }}
      onEvent={(event, error) => {
        if (event === "onReady") {
          if (!isSharePath(currentPath) && !keycloak.authenticated) {
            keycloak.login();
          }
        }
        if (event === "onAuthSuccess") {
          // eslint-disable-next-line no-console
          console.warn("🔑 Authenticated");
        }
        if (event === "onAuthError") {
          // eslint-disable-next-line no-console
          console.error("❌ Auth Error", error);
        }
      }}
      // onTokens={onKeycloakTokens}
    >
      {children}
    </ReactKeycloakProvider>
  );
}
